/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Button } from '@coursera/cds-core';
import { ClockOutlineIcon } from '@coursera/cds-icons';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import AttemptsDialog from 'bundles/grading/components/staff-graded-assignments/attempts/AttemptsDialog';

import _t from 'i18n!nls/grading';

const styles = {
  attemptsButton: css`
    color: var(--cds-color-neutral-primary-weak);
  `,
};

function AttemptsLink() {
  const { pageData, submissionHeaders, submissionData } = useContext(SGAPageContext);
  const { submitter } = submissionData.data || {};

  const submitterId = submitter?.submitterId || '';

  const groupId = pageData.currentContextId;
  const gradingGroupId = pageData.gradingGroupId;
  const itemId = pageData.currentItemId;

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const handleOpenDialog = () => setIsDialogOpen(true);
  const handleCloseDialog = () => setIsDialogOpen(false);

  if (submissionHeaders.loading || submissionHeaders.data.length <= 1) {
    return null;
  }

  return (
    <React.Fragment>
      <Button
        onClick={handleOpenDialog}
        icon={<ClockOutlineIcon size="small" />}
        iconPosition="before"
        variant="ghost"
        size="small"
        css={styles.attemptsButton}
      >
        {_t('Submission history')}
      </Button>
      <AttemptsDialog
        // Need to specify `key`, otherwise the `selectedAttemptId` state of the `AttemptsDialog` is preserved
        // between different submitters. This would cause incorrect values passed to the AttemptSelector.
        key={'attemptsDialog-' + submitterId}
        submissionHeaders={submissionHeaders.data}
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        groupId={groupId}
        itemId={itemId}
        submitterId={submitterId}
        gradingGroupId={gradingGroupId}
      />
    </React.Fragment>
  );
}

export default AttemptsLink;
